import type { QualityAccess } from "./access"

/** What a surface of the feature says while it is off, by who turned it off. Client-safe. */
export function qualityOffNotice(disabledBy: NonNullable<QualityAccess["disabledBy"]>): string {
  switch (disabledBy) {
    case "platform":
      return "Conversation Quality is turned off for this workspace. Contact support to turn it back on."
    case "tenant":
      return "Conversation Quality is turned off for this workspace."
    default: {
      const exhaustive: never = disabledBy
      return exhaustive
    }
  }
}
